import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { auth } from "../config/firebase";
import firebase from "firebase/compat/app";

const RedirectHandler = () => {
  const [user, setUser] = useState<firebase.User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return null; // or a loader

  if (user) {
    return <Navigate to="/admin" replace />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default RedirectHandler;
